import { registerSW } from 'virtual:pwa-register'
import { useEventListener } from '@vueuse/core'

export const usePwa = () => {
    const registerServiceWorker = () => {
        const intervalMS = 0.1 * 60 * 1000
    
        registerSW({
            onRegistered(r) {
                r && setInterval(() => {
                    // console.log('On Registered')
                    r.update()
                }, intervalMS)
            },
            onNeedRefresh() {
                console.log('Please refresh')
            },
            onOfflineReady() {
                // console.log('Offline mode is ready')
            }
        })
    }

    const trackPwaInstalled = () => {
        let isInstalled = localStorage.getItem('isPwaInstalled') === '1' || false

        if (window.matchMedia('(display-mode: standalone)').matches) {
            // User is currently navigating on the PWA so yes it's installed
            if (!isInstalled) {
                localStorage.setItem('isPwaInstalled', '1')
                isInstalled = true
                // Track accordingly
            }
        } else {
            //User is navigating in browser
            //User can get an installation prompt meaning the app is not installed
            useEventListener(window, 'beforeinstallprompt', () => {
                localStorage.setItem('isPwaInstalled', '0')
                isInstalled = false
            })
            useEventListener(window, 'appinstalled', () => {
                localStorage.setItem('isPwaInstalled', '1')
                isInstalled = true
                // Track accordingly
            })
        }
    }

    return {
        registerServiceWorker,
        trackPwaInstalled,
    }
}